import { IonButton } from '@ionic/react';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { IThemeColor } from '../theme/IThemeColor';
import { ISignInTrackingFrom } from './ISignInTrackingFrom';
import { AuthHandler } from './AuthHandler';

export const CreateAccountButton: React.FC<{color?: IThemeColor, trackingFrom: ISignInTrackingFrom }> = ({ color, trackingFrom }) => {
    const authHandler = useInstance(AuthHandler);

    const onClick = async () => {
        await authHandler.login({ trackingFrom });
    };

    return (
        <IonButton
            data-type="sign-in-or-create-account"
            fill="outline"
            expand="block"
            color={color}
            onClick={onClick}
        >
            Sign In or Create Account
        </IonButton>
    );
};
